if (!customElements.get('piecework-more-from')) {
  customElements.define(
    'piecework-more-from',
    class PieceworkMoreFrom extends HTMLElement {
      constructor() {
        super();
        this.elements = {
          slideshow: this.querySelector('.splide'),
          slideshowWrapper: this.querySelector('.more-from-slideshow'),
          slideCount: this.querySelectorAll('li').length,
          slideshowContainer: this.querySelector('.more-from-slideshow-container'),
          pagination: this.querySelectorAll('.pw-media-pagination div'),
          controls: {
            prev: this.querySelector('[data-prev]'),
            next: this.querySelector('[data-next]'),
          },
        };

        this.resizeSlideshow();

        const slider = new Splide(this.elements.slideshow, {
          type: 'loop',
          arrows: false,
          pagination: false,
          perPage: 2,
          speed: 600,
          perMove: 1,
          padding: { right: 60 },
          breakpoints: {
            768: {
              perPage: 1,
            },
          },
        }).mount();

        window.addEventListener('resize', this.resizeSlideshow.bind(this));

        this.elements.controls.prev.addEventListener('click', () => {
          slider.go('<');
        });
        this.elements.controls.next.addEventListener('click', () => {
          slider.go('>');
        });

        slider.on('move', () => {
          if (this.elements.pagination) {
            this.elements.pagination.forEach((page) => {
              const slide = parseInt(page.dataset.slide);
              if (slider.index === slide) {
                page.classList.add('tw-bg-current');
              } else {
                page.classList.remove('tw-bg-current');
              }
            });
          }
        });
      }

      resizeSlideshow() {
        const box = this.elements.slideshowWrapper.getBoundingClientRect();
        this.elements.slideshowContainer.style.width = box.width + (window.innerWidth - (box.x + box.width)) + 'px';
      }
    }
  );
}
